import { render } from "./MLogoSettingEditModal.vue?vue&type=template&id=52ab1e7e&scoped=true&ts=true"
import script from "./MLogoSettingEditModal.vue?vue&type=script&lang=ts"
export * from "./MLogoSettingEditModal.vue?vue&type=script&lang=ts"

import "./MLogoSettingEditModal.vue?vue&type=style&index=0&id=52ab1e7e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ab1e7e"]])

export default __exports__